import React from "react";
import Link from "next/link";

export default function MenuToList({ menu, depth = 0 }) {
  return (
    <ul>
      {menu.map((item, index) => {
        return (
          <li key={index}>
            <Link href={item.url} passHref>
              <a>{item.title}</a>
            </Link>
            {item.items && <MenuToList menu={item.items} depth={depth + 1} />}
          </li>
        );
      })}
    </ul>
  );
}
